// Defines the reusable taskbar actions rendered by the navigation bar.
const TASKBAR_ITEMS = [
  {
    id: "start",
    ariaLabel: "Start",
    icon: <div className="start-button" aria-hidden="true" />,
    variant: "start",
    onClick: () => console.log("Start button clicked"),
  },
  {
    id: "scanlines",
    ariaLabel: "Scanlines",
    icon: <div className="camera-button" aria-hidden="true" />,
    label: "Scanlines",
    variant: "action",
    onClick: () => console.log("Scanlines button clicked"),
  },
];

// Renders the app taskbar with a data-driven set of buttons.
export const NavigationBar = () => {
  return (
    <div
      className="navbar-container"
      style={{ position: "absolute", bottom: 0, zIndex: 9999 }}
    >
      {TASKBAR_ITEMS.map((item, index) => (
        <div key={item.id} className="navbar-item-group">
          {index === 1 ? <NavbarDivider /> : null}
          <TaskbarButton
            ariaLabel={item.ariaLabel}
            icon={item.icon}
            label={item.label}
            onClick={item.onClick}
            variant={item.variant}
          />
        </div>
      ))}
    </div>
  );
};

// Renders a shared Windows-style taskbar button for any action.
const TaskbarButton = ({ onClick, icon, label, ariaLabel, variant = "action" }) => {
  return (
    <button
      type="button"
      className={`taskbar-button taskbar-button--${variant}`}
      onClick={onClick}
      aria-label={ariaLabel || label}
    >
      {icon}
      {label ? <span className="button-text">{label}</span> : null}
    </button>
  );
};

// Renders the visual divider between taskbar groups.
export const NavbarDivider = () => {
  return <div className="navbar-divider" />;
};

// Renders the Start button with its dedicated taskbar styling.
export const StartButton = () => {
  const item = TASKBAR_ITEMS[0];

  return (
    <TaskbarButton
      ariaLabel={item.ariaLabel}
      icon={item.icon}
      onClick={item.onClick}
      variant={item.variant}
    />
  );
};

// Renders the secondary taskbar button for opening the scanlines window.
export const NewButton = () => {
  const item = TASKBAR_ITEMS[1];

  return (
    <TaskbarButton
      ariaLabel={item.ariaLabel}
      icon={item.icon}
      label={item.label}
      onClick={item.onClick}
      variant={item.variant}
    />
  );
};
